import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required } from '@vuelidate/validators';
import AccountService from '@/services/AccountService';
const zipLength = function (value) {
  if (!value) return true;
  return value.length >= 4;
};
export default {
  props: {
    mainaddress: {
      type: Object,
      default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    states: {
      type: Array,
      default: () => {
        return [];
      }
    },
    countries: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      searchZip: false,
      initialSetup: true,
      address: {
        address1: null,
        address2: null,
        zip: null,
        city: null,
        state: null,
        state_id: null,
        country_id: null
      }
    };
  },
  mounted() {
    this.setAddress(this.mainaddress);
    if (this.isRegistration) {
      this.$v.address.$touch();
    }
  },
  methods: {
    getErrors: function (field, validators) {
      const err = [];
      if (!this.$v.address[field].$dirty) return err;
      validators.forEach(e => {
        if (this.$v.address[field][e].$invalid) {
          if (e === 'required' && !this.isRegistration) {
            err.push('This field is required');
          }
          if (e === 'minLength') {
            err.push(field.capitalize() + ' must be at least ' + this.$v.address[field].minLength.$params.min + ' characters');
          }
          if (e === 'zipLength' && this.address.zip != null && this.address.zip.length < 5 && (this.address.country_id == null || +this.address.country_id === 184)) {
            err.push(`Given ${field.capitalize()} is not a valid United States Zipcode.`);
          }
        }
      });
      return err;
    },
    handleZipInput() {
      const zip = this.address.zip || '';
      if (zip.length > 5) {
        this.checkZip();
      }
    },
    handleZipBlur() {
      this.$v.address.zip.$touch();
      const zip = this.address.zip || '';
      if (zip.length === 4 || zip.length === 5) {
        this.checkZip();
      }
    },
    handleZipEnter() {
      const zip = this.address.zip || '';
      if (zip.length === 4 || zip.length === 5) {
        this.checkZip();
      }
    },
    checkZip: function () {
      if (this.$v.address.zip.$invalid) {
        return;
      }
      this.searchZip = true;
      AccountService.checkZip(this.address.zip).then(response => {
        if (response && response.data && response.data.locale && response.data.locale.state_id) {
          this.address.country_id = response.data.locale.country_id;
          const state = this.states.filter(i => +i.id === +response.data.locale.state_id);
          if (state.length === 1) {
            this.address.state = state[0].abbreviation;
            this.address.state_id = state[0].id;
          }
          this.address.city = response.data.locale.city;
        }
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.searchZip = false;
      });
    },
    stateSelect: function () {
      this.$v.address.state.$touch();
      const state = this.states.filter(i => i.id === this.address.state_id);
      if (state.length === 1) {
        this.address.state = state[0].abbreviation;
      }
    },
    setAddress: function (address) {
      if (address) {
        // fix zip code padding if needed.
        address.zip = ('' + address.zip + '').padStart(5, '0');
        this.address = Object.assign({}, address);
      }
    },
    getFormState(field) {
      if (this.isRegistration) {
        return !this.$v.address[field].$error;
      } else {
        return !this.$v.address[field].$error ? null : false;
      }
    }
  },
  computed: {
    statesByCountry() {
      if (this.address.country_id) {
        return this.states.filter(e => +e.country_id === +this.address.country_id);
      } else {
        return this.states;
      }
    }
  },
  watch: {
    '$v.$invalid': function () {
      this.$emit('isValid', !this.$v.$invalid);
    },
    address: {
      deep: true,
      handler() {
        if (this.initialSetup) {
          if (this.address.state && !this.address.state_id) {
            const state = this.states.filter(i => i.abbreviation === this.address.state);
            if (state.length === 1) {
              this.address.state_id = state[0].id;
            }
          }
          if (this.address.state_id && !this.address.state) {
            const state2 = this.states.filter(i => i.id === this.address.state_id);
            if (state2.length === 1) {
              this.address.state = state2[0].abbreviation;
            }
          }
          this.initialSetup = false;
        }
        this.address.valid = !this.$v.$invalid;
        this.$emit('dataChange', this.address);
      }
    },
    /**
     * When you pass in props and assign on mounted, you have to watch
     * for changes, particularly if the data is pulled via ajax,
     * since it won't be anything on the mount
     */
    mainaddress: function (n) {
      this.setAddress(n);
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    address: {
      address1: {
        required
      },
      zip: {
        required,
        zipLength
      },
      city: {
        required
      },
      state: {
        required
      },
      country_id: {
        required
      }
    }
  }
};